import React from "react";
import { useField } from "formik";
import { Alert, Input } from "@material-tailwind/react";

const FormikInputIcon = React.forwardRef(function FormikInputIcon({
    iconName,
    color = "black",
    ...props
}, ref) {
    const [field, meta] = useField(props);

    return (
        <>
            <Input
                {...field}
                {...props}
                ref={ref}
                color={color} // label, underline, text
                icon={
                    <span className="material-icons text-black text-base leading-none align-middle">
                        {iconName} {/* <-- dynamically change icon here */}
                    </span>
                }
                error={meta.touched && meta.error ? true : undefined}
                className={`!text-black placeholder:!text-black`}
                labelProps={{
                    className: `!text-black peer-placeholder-shown:!text-black peer-focus:!text-black max-w-full truncate`,
                }}
            />
            {meta.touched && meta.error && (
                <Alert color="red" className="mt-1 rounded-lg py-1 pl-5">
                    {meta.error}
                </Alert>
            )}
        </>
    );
});

export default FormikInputIcon;
